/* Atlanta Legacy Falcons Tee — keep redundant Category option synchronized with Color. */
(function () {
  function markCategoryGroup(root) {
    if (!root || root.dataset.productHandle !== 'atlanta-legacy-001') return;
    root.querySelectorAll('.product-form__input').forEach(function (group) {
      var label = group.querySelector('legend.form__label, label.form__label');
      if (label && label.textContent.trim().replace(/:$/, '').trim().toLowerCase() === 'category') {
        group.setAttribute('data-legacy-category', 'true');
      }
    });
  }

  function syncCategory(root, colorValue) {
    if (!root || root.dataset.productHandle !== 'atlanta-legacy-001') return;
    var mapped = String(colorValue).toLowerCase() === 'black' ? 'Black' : 'Cream';
    var categoryGroup = null;
    root.querySelectorAll('.product-form__input').forEach(function (group) {
      var label = group.querySelector('legend.form__label, label.form__label');
      if (label && label.textContent.trim().replace(/:$/, '').trim().toLowerCase() === 'category') categoryGroup = group;
    });
    if (!categoryGroup) return;
    categoryGroup.setAttribute('data-legacy-category', 'true');
    var radio = Array.from(categoryGroup.querySelectorAll('input[type="radio"]')).find(function (input) {
      return input.value === mapped;
    });
    if (radio) {
      radio.checked = true;
      return;
    }
    var select = categoryGroup.querySelector('select');
    if (select) {
      Array.from(select.options).forEach(function (option) {
        option.selected = option.value === mapped;
        if (option.value === mapped) option.setAttribute('selected', 'selected');
        else option.removeAttribute('selected');
      });
    }
  }

  function isColorControl(target) {
    if (!target || !target.closest) return false;
    var group = target.closest('.product-form__input');
    if (!group) return false;
    var label = group.querySelector('legend.form__label, label.form__label');
    return !!label && label.textContent.trim().replace(/:$/, '').trim().toLowerCase() === 'color';
  }

  document.addEventListener('change', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('variant-selects[data-product-handle="atlanta-legacy-001"]') : null;
    if (!root || !isColorControl(event.target)) return;
    var value = event.target.tagName === 'SELECT' ? event.target.value : event.target.value;
    syncCategory(root, value);
  }, true);

  function initialize() {
    document.querySelectorAll('variant-selects[data-product-handle="atlanta-legacy-001"]').forEach(function (root) {
      markCategoryGroup(root);
      var colorGroup = null;
      root.querySelectorAll('.product-form__input').forEach(function (group) {
        var label = group.querySelector('legend.form__label, label.form__label');
        if (label && label.textContent.trim().replace(/:$/, '').trim().toLowerCase() === 'color') colorGroup = group;
      });
      if (!colorGroup) return;
      var selected = colorGroup.querySelector('input:checked, select');
      if (selected) syncCategory(root, selected.value);
    });
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('change', function () { setTimeout(initialize, 0); });
})();
